import { createApp } from 'vue';
import { createPinia } from 'pinia';
import * as Sentry from '@sentry/vue';
import App from './App.vue';
import router from './router';
import autofocus from './directives/autofocus';
import { vHint } from '@a365/ui/directives'

import '../node_modules/@a365/ui/dist/css/color-theme-setup.css';
import '../node_modules/@a365/ui/dist/css/app-webui.css';
import '../node_modules/@a365/ui/dist/css/components.css';
import './assets/base.scss';
import './assets/a-365-rewrite.scss';
import '../node_modules/lib-stripe-vue3/dist/lib-stripe-vue3.css';

const app = createApp(App);

export const pinia = createPinia();

app.use(pinia);

const dsn = import.meta.env['VITE_SENTRY_DSN'] as string | undefined;

// These types of errors occur in the following cases:
// - User navigates to another page while there are active API requests
// - The Internet connection is broken while there are active API requests
// That means these errors can be ignored
const failedToFetchErrorsToIgnore = [
  'NetworkError when attempting to fetch resource.', // Captures Firefox noise
  'TypeError: Failed to fetch', // Captures Chrome noise
  'TypeError: Load failed', // Captures Safari noise
];

Sentry.init({
  app,
  dsn,
  environment: import.meta.env.MODE,
  release: `${import.meta.env['VITE_APP_NAME']}@${import.meta.env['VITE_APP_VERSION']}`,
  attachProps: true,
  attachStacktrace: true,
  //trackComponents: false,
  integrations: [
    Sentry.browserTracingIntegration({ router })
  ],
  maxBreadcrumbs: 10,
  sendClientReports: true,
  //autoSessionTracking: false,
  //enableTracing: false,
  sampleRate: 1.0,
  ignoreErrors: [
    ...failedToFetchErrorsToIgnore,
    'Failed to fetch dynamically imported module', // Occurs after front-end is deployed when assets' hashes are changed
    'Importing a module script failed', // Occurs after front-end is deployed when assets' hashes are changed
  ],
});

app.directive('autofocus', autofocus);
app.directive('hint', vHint);

app.use(router);

app.config.errorHandler = (err) => {
  Sentry.captureException(err, {
    level: 'fatal'
  });
}

app.mount('#app');
